import '../profile.scss';
import React from 'react';
import { Row, Col, UncontrolledTooltip, Button, ModalBody } from 'reactstrap';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faArrowAltCircleRight } from '@fortawesome/free-solid-svg-icons';
import { colors } from 'app/config/color';
import { connect } from 'react-redux';
import {
  updateAttribute,
  getProvince,
  resetInfoAddress,
  getGuild,
  getDistrict,
  getUserProfile,
  handleGetUserInfo,
  sendOtpMapping
} from '../user.reducer';
import { IRootState } from 'app/shared/reducers';
import moment from 'moment';
import { APP_LOCAL_DATE_FORMAT, MALE, FEMALE, ENP, IND, ORG, Resources, KEY_STORAGE, MESSAGE } from 'app/config/constants';
import UpdateIdentity from './update-identity';
import ModalShareInfoResidential from './modal-share-info-residential';
import ModalUpdateDataWithResidential from './modal-update-data-residential';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import VerifyOtpEditInfo from './verify-otp-edit-info';
import { reSendOtp } from 'app/modules/sendOtp/sendOtp.reducer';
import ModalCancelAccount from 'app/modules/account/user/identity-info/modal-cancel-account';
import ListModalCancelAccount from 'app/modules/account/user/identity-info/list-modal-cancel-account';
import { handleGetUserList } from 'app/modules/administration/approve-management/approve-management.reducer';
import InfoAccount from 'app/modules/account/user/identity-info/modal-info-account';
import AddIdentity from 'app/modules/account/user/identity-info/add-identity';
import ConfirmMappingOtp from 'app/modules/account/user/identity-info/cofirm-mapping';
import UpdateApproveIdentity from 'app/modules/account/user/identity-info/update-approve-identity';
import PasswordResetModal from 'app/modules/account/user/auth/password-reset-modal';

export interface IdentityInfoProps extends StateProps, DispatchProps {
  dictInfoAddress: any;
}
export interface IdentityInfoState {
  modal: boolean;
  showInput: boolean;
  showFormUpdate: boolean;
  showInputAdd: boolean;
  showOTP: boolean;
  lstAttr: any;
  showMessage: boolean;
  showModalConfirm: boolean;
  messageModalConfirm: string;
  valuesInput: any;
  showModalSelect: boolean;
  showModalCancelAccount: boolean;
  showListModalCancelAccount: boolean;
  showModalInfoAccount: boolean;
  typeStr: string;
  bornPlace: string;
  originLocal: string;
  address: string;
  permanentAddress: string;
  birthday: Date;
  required: boolean;
  isResetAddress: boolean;
  isResetOriginLocal: boolean;
  isResetBornPlace: boolean;
  isResetpermanentAddress: boolean;
  disableButtonReg: boolean;
  nameProvince: string;
  nameDistrict: string;
  nameCommune: string;
  nameAddress: string;
  showModalAttribute: boolean;
  showModalUpdateResidential: boolean;
  isUpdateIdentity: boolean;
  updateInfoWithResource: boolean;
  isShareInfoResidential: boolean;
  isConfirmMapping: boolean;
  isDropDownOpen: boolean;
  typeUpdate: string;
  userInfoCancel: any;
  resetPassword: boolean;
}
export class IdentityInfo extends React.Component<IdentityInfoProps, IdentityInfoState> {
  state: IdentityInfoState = {
    modal: false,
    showInput: false,
    showFormUpdate: false,
    showInputAdd: false,
    showOTP: false,
    showMessage: false,
    lstAttr: [],
    showModalConfirm: false,
    messageModalConfirm: '',
    valuesInput: {},
    showModalSelect: false,
    typeStr: '',
    bornPlace: '',
    originLocal: '',
    address: '',
    permanentAddress: '',
    birthday: null,
    required: false,
    isResetAddress: false,
    isResetBornPlace: false,
    isResetOriginLocal: false,
    isResetpermanentAddress: false,
    disableButtonReg: false,
    nameProvince: '',
    nameDistrict: '',
    nameCommune: '',
    nameAddress: '',
    showModalAttribute: false,
    showModalUpdateResidential: false,
    isUpdateIdentity: false,
    updateInfoWithResource: false,
    isShareInfoResidential: false,
    isDropDownOpen: false,
    showModalCancelAccount: false,
    showListModalCancelAccount: false,
    typeUpdate: '',
    showModalInfoAccount: false,
    userInfoCancel: {},
    isConfirmMapping: false,
    resetPassword: false
  };
  componentWillMount() {
    this.props.getProvince();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.resUpdateAttr !== nextProps.resUpdateAttr) {
      this.setState({
        showModalUpdateResidential: false,
        isShareInfoResidential: false
      });
    }
  }

  toggle = () => {
    this.setState({
      isDropDownOpen: !this.state.isDropDownOpen
    });
  };

  dataBinding = (item, index) => {
    return (
      <div className="row">
        <div className={window.innerWidth < 768 ? 'col-12' : 'col-sm-3'}>
          {item.name == 'identity' ? (
            <label>Số CMT (9 số)</label>
          ) : item.name == 'citizenId' ? (
            <label>Số CMT/CCCD</label>
          ) : item.name == 'identityVerified' ? null : item.name == 'citizenIdVerified' ? null : item.name == 'mail' ? (
            <label>Email</label>
          ) : (
            <label>{item.label}</label>
          )}
        </div>

        <div style={{ textOverflow: 'ellipsis' }} className={window.innerWidth < 768 ? 'col-10' : 'col-sm-6'}>
          {this.renderText(item)}
        </div>

        <div className={window.innerWidth < 768 ? 'col-2' : 'col-sm-3'} style={{ textAlign: 'center' }}>
          <div>{this.renderIcon(item.name, item.value)}</div>
        </div>

        {/*<div className={window.innerWidth < 768 ? 'col-2' : 'col-sm-3'} style={{ textAlign: 'center' }}>*/}
        {/*  {item.name == 'identityVerified' || item.name == 'citizenIdVerified' ? null : item.loa ? (*/}
        {/*    <div>*/}
        {/*      <p style={{ cursor: 'pointer' }} id={item.name}>*/}
        {/*        {this.renderIcon(item.loa, item.value)}*/}
        {/*      </p>*/}
        {/*      <UncontrolledTooltip style={{ background: '#fff', color: '#373a3c' }} placement="top" target={item.name}>*/}
        {/*        {this.renderTooltip(item.loa)}*/}
        {/*      </UncontrolledTooltip>*/}
        {/*    </div>*/}
        {/*  ) : (*/}
        {/*    <div>{this.renderIcon(item.loa, item.value)}</div>*/}
        {/*  )}*/}
        {/*</div>*/}
      </div>
    );
  };
  renderText = item => {
    switch (item.name) {
      case 'dateOfBirth':
        return <label className="font-weight-bold">{item.value ? item.value : ''}</label>;
      case 'gender':
        return <label className="font-weight-bold">{item.value === MALE ? 'Nam' : item.value === FEMALE ? 'Nữ' : ''}</label>;
      case 'identity':
        return (
          <div>
            {item.value === null || item.value === '' ? (
              <Button
                onClick={() => this.updateIdentityOrCitizenId('identity')}
                style={{ backgroundColor: '#4D9235', border: '0px', color: 'white', borderRadius: '10px' }}
              >
                Cập nhật
              </Button>
            ) : (
              <label className="font-weight-bold">{item.value}</label>
            )}
            {/* {item.value != null ? (
              item.value != 'Chờ phê duyệt' ? (
                <label className="font-weight-bold">{item.value}</label>
              ) : (
                <label className="font-weight-bold" style={{ color: '#ff7518c7' }}>
                  Chờ phê duyệt
                </label>
              )
            ) : (
              ''
            )} */}
          </div>
        );
      //return <label className="font-weight-bold">{item.value != null ? item.value != 'Chờ phê duyệt' ? item.value : 'Chờ phê duyệt' : ''}</label>;
      case 'citizenId':
        return (
          <div>
            {item.value === null || item.value === '' ? (
              <button
                onClick={() => this.updateIdentityOrCitizenId('citizenId')}
                style={{ backgroundColor: '#4D9235', border: '0px', color: 'white', borderRadius: '10px' }}
              >
                Cập nhật
              </button>
            ) : (
              <label className="font-weight-bold">{item.value}</label>
            )}
          </div>
        );
      // return <label className="font-weight-bold">{item.value != null ? item.value != 'Chờ phê duyệt' ? item.value : 'Chờ phê duyệt' : ''}</label>;
      case 'identityVerified':
      case 'citizenIdVerified':
        return null;
      default:
        return (
          <label className="font-weight-bold" style={{ display: 'block' }}>
            {item.value ? item.value : ''}
          </label>
        );
      // return <label className="font-weight-bold">{item.value ? item.value : ''}</label>;
    }
  };
  updateIdentityOrCitizenId = type => {
    if (type === 'identity') {
      this.setState({ isUpdateIdentity: true });
    } else {
      this.setState({ isUpdateIdentity: false });
    }
    this.displayModalDataResidential();
  };
  updateUser = e => {
    e.preventDefault();
    this.setState(prevState => ({
      showInput: true
    }));
  };

  verifyOtpEdit = e => {
    e.preventDefault();
    if (this.props.account && this.props.account.configApproveUpdate && this.props.account.configApproveUpdate === '0') {
      this.setState({
        showFormUpdate: true
      });
    } else {
      this.props.reSendOtp(this.props.userProfile.email, 'EMAIL', MESSAGE.OTP);
      this.setState(prevState => ({
        showOTP: true,
        typeUpdate: 'UPDATE'
      }));
    }
  };

  toggleResetPassword = () => {
    this.setState(prevState => ({
      //showModalAdd: false,
      resetPassword: !prevState.resetPassword
    }));
  };

  verifyOtpAdd = e => {
    e.preventDefault();
    this.props.reSendOtp(this.props.userProfile.email, 'EMAIL', MESSAGE.OTP);
    this.setState(prevState => ({
      showOTP: true,
      typeUpdate: 'ADD'
    }));
  };

  renderIcon = (name, value) => {
    if (this.props.resUserInfoApprove && this.props.resUserInfoApprove.length > 0) {
      const data = JSON.parse(this.props.resUserInfoApprove[0].requestData);
      if (name === 'dateOfBirth') {
        const dob = data[name] ? moment(data[name]).format(APP_LOCAL_DATE_FORMAT) : '';
        if (dob && value !== dob) {
          return <span style={{ color: '#FF7518' }}>Chờ phê duyệt</span>;
        }
      } else if (data[name] && value !== data[name]) {
        return <span style={{ color: '#FF7518' }}>Chờ phê duyệt</span>;
      }
    }
    return null;
    // if (value) {
    //   if (attrLoa) return <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />;
    //   return <FontAwesomeIcon icon={faExclamationTriangle} color={colors.colorWarning} />;
    // }
    // return <FontAwesomeIcon icon={faArrowAltCircleRight} color={colors.colorDanger} />;
  };
  renderTooltip = loa => {
    let text = 'Thông tin này được xác minh bởi ';
    if (loa.src) {
      text += loa.src + ' ';
    }
    if (loa.validDate) {
      text += moment(loa.validDate).format(APP_LOCAL_DATE_FORMAT);
    }
    if (loa.expiredDate) {
      text += ' - ' + moment(loa.expiredDate).format(APP_LOCAL_DATE_FORMAT);
    }
    return text;
  };
  closeModalUpdateIdentity = () => {
    this.setState({
      showFormUpdate: false,
      showModalUpdateResidential: false
    });
  };

  closeModalUpdateApproveIdentity = () => {
    this.setState({
      showInput: false,
      showModalUpdateResidential: false
    });
    this.props.getUserProfile();
  };

  closeModalAddIdentity = () => {
    this.setState({
      showInputAdd: false,
      showModalUpdateResidential: false
    });
    // this.props.getUserProfile();
  };

  closeModalVerifyOtp = () => {
    this.setState({
      showOTP: false
    });
  };

  closeModalConfirmMappingOtp = () => {
    this.setState({
      isConfirmMapping: false
    });
  };

  verifyOtpSuccess = () => {
    this.setState({
      showOTP: false,
      showInput: true
    });
  };

  showListModalCancelAccount = () => {
    let userType;
    if (this.props.userProfile && this.props.userProfile.userType === '1') {
      userType = 'IND';
    } else {
      userType = 'ORG';
    }
    this.props.handleGetUserList(userType, 'CANCELLATION', 1, 1000000, null, null);
    this.setState({
      showListModalCancelAccount: true,
      showModalCancelAccount: false,
      showModalInfoAccount: false
    });
  };

  closeModalCancelAccount = () => {
    this.setState({
      showModalCancelAccount: false
    });
  };

  closeListModalCancelAccount = () => {
    this.setState({
      showListModalCancelAccount: false,
      showModalCancelAccount: true
    });
  };

  closeModalInfoAccount = () => {
    this.setState({
      showModalInfoAccount: false,
      showListModalCancelAccount: true
    });
  };

  showModalInfoUserCancel = item => {
    this.setState({
      showModalInfoAccount: true,
      showListModalCancelAccount: false,
      userInfoCancel: item
    });
  };

  displayModalDataResidential = () => {
    this.setState({ showModalUpdateResidential: true });
  };
  closeModalUpdateDataWithResidential = () => {
    this.setState({ showModalUpdateResidential: false, isShareInfoResidential: false });
  };
  updateUserProfileWithResidential = (values, resource) => {
    if (this.props.userProfile && this.props.userProfile.attributes) {
      this.props.userProfile.attributes.map(item => {
        Object.entries(values).map(([key, val]) => {
          if (resource === Resources[2].key) {
            switch (item.name) {
              case 'identity':
              case 'identityVerified':
                item.value = values.identity;
                break;
              case 'citizenId':
              case 'citizenIdVerified':
                item.value = values.citizenId;
                break;
            }
          }
          if (item.name === key) {
            item.value = values[key] ? values[key].trim() : null;
            if (item.id == '') {
              item.id = null;
            }
            return;
          }
        });
      });
    }
    var sic = null;
    var tax = null;
    if (resource === Resources[2].key) {
      this.setState({
        updateInfoWithResource: true
      });
      tax = values.tax;
    } else {
      this.setState({
        updateInfoWithResource: false
      });
    }
    if (resource === Resources[6].key) {
      localStorage.setItem(KEY_STORAGE.UPDATE_DATA_RESIDENTIAL, JSON.stringify('CSDL Quốc gia về Dân cư'));
    }
    this.props.updateAttribute(this.props.userProfile.attributes, resource, sic, tax);
  };
  shareDataResidential = () => {
    this.setState({ isShareInfoResidential: true });
  };

  confirmMapping = () => {
    this.setState({ isConfirmMapping: true });
    this.props.sendOtpMapping();
  };

  getInfoResidential = values => {
    if (this.props.userProfile && this.props.userProfile.attributes) {
      this.props.userProfile.attributes.map(item => {
        Object.entries(values).map(([key, val]) => {
          if (item.name === key && key === 'dateOfBirth') {
            item.value = moment(val).format(APP_LOCAL_DATE_FORMAT);
            return;
          }
          if (item.name === key) {
            item.value = values[key] ? values[key].trim() : null;
            if (item.id == '') {
              item.id = null;
            }
            return;
          }
        });
      });
    }
    var sic = null;
    var tax = null;
    this.props.updateAttribute(this.props.userProfile.attributes, Resources[7].key, sic, tax);
  };
  render() {
    return (
      <div className="col-md-12 col-sm-12 borderStyle">
        <VerifyOtpEditInfo
          id={this.props.userProfile.email}
          isDisplay={this.state.showOTP}
          invokeCloseModal={this.closeModalVerifyOtp}
          invokeSuccess={this.verifyOtpSuccess}
        />
        <ConfirmMappingOtp isDisplay={this.state.isConfirmMapping} invokeCloseModal={this.closeModalConfirmMappingOtp} />
        <ModalCancelAccount
          isDisplay={this.state.showModalCancelAccount}
          invokeCloseModal={this.closeModalCancelAccount}
          showListCancelAccount={this.showListModalCancelAccount}
        />
        <ListModalCancelAccount
          isDisplay={this.state.showListModalCancelAccount}
          invokeCloseModal={this.closeListModalCancelAccount}
          showModalInfoUser={this.showModalInfoUserCancel}
        />
        <InfoAccount
          isDisplay={this.state.showModalInfoAccount}
          invokeCloseModal={this.closeModalInfoAccount}
          data={this.state.userInfoCancel}
        />
        <UpdateIdentity
          isDisplay={this.state.showFormUpdate}
          infoUserProfile={this.props.userProfile}
          invokeCloseModal={this.closeModalUpdateIdentity}
          dictInfoSelect={this.props.dictInfoAddress}
          updateInfoWithResource={this.state.updateInfoWithResource}
          type={this.state.typeUpdate}
        />
        <UpdateApproveIdentity
          isDisplay={this.state.showInput}
          infoUserProfile={this.props.userProfile}
          invokeCloseModal={this.closeModalUpdateApproveIdentity}
          dictInfoSelect={this.props.dictInfoAddress}
          updateInfoWithResource={this.state.updateInfoWithResource}
          type={this.state.typeUpdate}
        />

        <AddIdentity
          isDisplay={this.state.showInputAdd}
          infoUserProfile={this.props.userProfile}
          invokeCloseModal={this.closeModalAddIdentity}
        />
        <ModalUpdateDataWithResidential
          showModal={this.state.showModalUpdateResidential}
          closeModal={this.closeModalUpdateDataWithResidential}
          updateWithResidential={this.updateUserProfileWithResidential}
          isUpdateIdentity={this.state.isUpdateIdentity}
        />
        <ModalShareInfoResidential
          showModal={this.state.isShareInfoResidential}
          closeModal={this.closeModalUpdateDataWithResidential}
          getInfo={this.getInfoResidential}
        />

        <PasswordResetModal modalShow={this.state.resetPassword} handleClose={this.toggleResetPassword} />

        <div className="row">
          <div className="col-3">
            <h4 className="font-weight-bold">Thông tin định danh</h4>
          </div>

          {this.props.account && this.props.account.bindStatus && this.props.account.bindStatus === 'PENDING' ? (
            <div className="col-4">
              {/*<FontAwesomeIcon icon={faPencilAlt} color="#4D9235" />*/}
              <label onClick={this.confirmMapping} id="linkStyle" className="font-weight-bold">
                Xác nhận liên kết
              </label>
            </div>
          ) : (
            <div className="col-4" />
          )}

          <div className="col-1" style={{ textAlign: 'center' }}>
            <Dropdown isOpen={this.state.isDropDownOpen} toggle={this.toggle}>
              <DropdownToggle className="drop-down" caret>
                Đăng ký
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  className="drop-down-item"
                  style={{ width: 'max-content' }}
                  key="1"
                  onClick={() => this.setState({ showInputAdd: true })}
                >
                  Đăng ký bổ sung thông tin
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="drop-down-item"
                  style={{ width: 'max-content' }}
                  key="2"
                  onClick={() => {
                    this.setState({ showModalCancelAccount: true });
                  }}
                >
                  Đăng ký hủy tài khoản
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="col-2" style={{ textAlign: 'center' }}>
            {/* {this.isHiddenBtnEdit() ? null : ( */}
            <Button className="btnEdit" onClick={this.verifyOtpEdit}>
              Chỉnh sửa
            </Button>
          </div>
          <div className="col-2" style={{ textAlign: 'center' }}>
            {/* {this.isHiddenBtnEdit() ? null : ( */}
            <Button className="btnEdit" onClick={this.toggleResetPassword}>
              Đổi mật khẩu
            </Button>
          </div>
        </div>
        <hr />
        {this.props.userProfile && this.props.userProfile.attributes
          ? this.props.userProfile.attributes.map((item, index) =>
              this.props.userProfile.userType == IND && (index < 12 || item.name == 'mobile' || item.name == 'mail')
                ? this.dataBinding(item, index)
                : this.props.userProfile.userType == ENP && index < 5
                ? this.dataBinding(item, index)
                : this.props.userProfile.userType == ORG && index < 6
                ? this.dataBinding(item, index)
                : null
            )
          : null}
        {/*<div style={{ marginLeft: '15px' }}>*/}
        {/*  <div className="row">*/}
        {/*    <label style={{ fontStyle: 'italic', color: '#4D9235' }}>Ghi chú về các biểu tượng dữ liệu:</label>*/}
        {/*  </div>*/}
        {/*  <div className="row">*/}
        {/*    <label style={{ fontStyle: 'italic', color: '#4D9235' }}>*/}
        {/*      <span style={{ marginRight: '5px' }}>*/}
        {/*        <FontAwesomeIcon icon={faCheckCircle} color={colors.colorSuccess} />*/}
        {/*      </span>*/}
        {/*      Biểu tượng Xanh là các thông tin đã được xác minh với Cơ sở dữ liệu Dân cư Quốc gia hoặc CSDL tin cậy khác*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*  <div className="row">*/}
        {/*    <label style={{ fontStyle: 'italic', color: '#4D9235' }}>*/}
        {/*      <span style={{ marginRight: '5px' }}>*/}
        {/*        <FontAwesomeIcon icon={faExclamationTriangle} color={colors.colorWarning} />*/}
        {/*      </span>*/}
        {/*      Biểu tượng Vàng là các thông tin do Người dùng tự nhập và chưa được xác minh với 1 CSDL tin cậy*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*  <div className="row">*/}
        {/*    <label style={{ fontStyle: 'italic', color: '#4D9235' }}>*/}
        {/*      <span style={{ marginRight: '5px' }}>*/}
        {/*        <FontAwesomeIcon icon={faArrowAltCircleRight} color={colors.colorDanger} />*/}
        {/*      </span>*/}
        {/*      Biểu tượng Đỏ là các trường thông tin không có dữ liệu*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
    );
  }
}
const mapStateToProps = (storeState: IRootState) => ({
  listAttr: storeState.userInfo.listAttr,
  resUpdateAttr: storeState.userInfo.resUpdateAttr,
  userProfile: storeState.userInfo.userProfile,
  province: storeState.userInfo.province,
  district: storeState.userInfo.district,
  guild: storeState.userInfo.guild,
  resUserInfoApprove: storeState.userInfo.resInfoApprove,
  account: storeState.authentication.account
});
const mapDispatchToProps = {
  updateAttribute,
  getProvince,
  resetInfoAddress,
  getDistrict,
  getGuild,
  getUserProfile,
  reSendOtp,
  handleGetUserList,
  sendOtpMapping
};
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdentityInfo);
